import React, { useEffect, useState } from "react";
import SimpleButton, { makeSimpleButton } from "../misc/elements/SimpleButton";

const OverviewButtonsBar = ({
  onOverviewButtonClicked,
  selectedCollection,
}) => {
  const [simpleButtons, setSimpleButtons] = useState([]);
  function createSimpleButtons() {
    const buttons = [
      makeSimpleButton({
        description: "Open",
        onClick: onOverviewButtonClicked,
        payload: "open",
        icon: "/icons/icon_box.png",
        width: "150px",
        height: "30px",
        backgroundColor: "#7f7f7f",
        textColor: "black",
        borderColor: "black",
      }),
      makeSimpleButton({
        description: "Saved",
        onClick: onOverviewButtonClicked,
        payload: "saved",
        icon: "/icons/icon_save.png",
        width: "150px",
        height: "30px",
        backgroundColor: "#5f5f5f",
        textColor: "white",
        borderColor: "#2f2f2f",
      }),
      makeSimpleButton({
        description: "History",
        onClick: onOverviewButtonClicked,
        payload: "history",
        width: "150px",
        height: "30px",
        backgroundColor: "#7f7f7f",
        textColor: "white",
        borderColor: "#5f5f5f",
      }),
    ];
    setSimpleButtons(buttons);
  }

  useEffect(() => {
    createSimpleButtons();
  }, []);
  return (
    <div
      className="divRow"
      style={{ width: "50%", justifyContent: "space-around", marginTop: "5px" }}
    >
      {simpleButtons.map((sb, index) => (
        <SimpleButton {...sb} key={index} selectedItem={selectedCollection} />
      ))}
    </div>
  );
};

export default OverviewButtonsBar;
